import React, { useEffect, useState, useRef, useMemo, useCallback} from 'react';
import DataGrid, { SortDirection } from 'react-data-grid';
import './grid.css';

const highlightClassname = "highlightClassname";
const selectedHighlightClassname = "selectedHighlightClassname";

function Screen3Grid(props:any) {

    let gridData:any = props.gridData;
    let bulkData:any = props.bulkData;
    const initData:any  = props.initialization;
    const focusTarget:any = useRef();

    let selectedRowVarId:string = "";
    const [[sortColumn, sortDirection], setSort] = useState<[string, SortDirection]>(['bulk_name', 'NONE']);
    const handleSort = useCallback((columnKey: string, direction: SortDirection) => {
        setSort([columnKey, direction]);
      }, []);
    let [rows, setRows] = useState<any[]>([]);

    const columns = useMemo(() =>{
        return [
            {
                key: 'lineage_id_cindel',
                name: 'Lineage ID',
                frozen: true,
                resizable: true,
                sortable: true, 
            },
            {
                key: 'CHROM', 
                name: 'CHROM' ,
                resizable: true,
                sortable: true, 
                width: 100
            },
            { key: 'POS', name: 'POS', resizable: true, sortable: true, },
            { key: 'REF', name: 'REF', width: 80 , resizable: true, sortable: true, },
            { key: 'ALT', name: 'ALT', width: 80 , resizable: true, sortable: true, },
            { key: 'read_depth',          name: 'Read depth' ,               resizable: true, sortable: true, },
            { key: 'n_var',               name: 'No. of variant reads',     resizable: true, sortable: true,},
            { key: 'vaf',                 name: 'VAF',                      resizable: true, sortable: true,},
            { key: 'Gene_name',           name: 'Gene name',                resizable: true, sortable: true,},
            { key: 'Exonic_variant_type', name: 'Exonic variant type' , resizable: true, sortable: true, },
            { key: 'Amino_acid_change',   name: 'Amino acid change' ,   resizable: true, sortable: true, },
        ];  
    },[rows]);
     
    
    let [cardTitle, setCardTitle] = useState<string>("Early embryonic mutations");

    initData.click_on_path = function(bulkId:string, dataKey:string){
        let datas:any[] = [];
        let tempCardTitle:string = "Early embryonic mutations" ;

        if(dataKey){
            tempCardTitle += " in " + dataKey;
        }

        if(gridData[dataKey]){
            let bulkDataForDatakey:any = bulkData[dataKey];

            if(bulkDataForDatakey){
                for(let i=0; i<gridData[dataKey].length; i++){
                    let rowData:any     = gridData[dataKey][i];
                    let var_id:string   = rowData.var_id;
                    let bulkDatas:any[] = bulkDataForDatakey[var_id];

                    if(bulkDatas){
                        bulkDatas.forEach(bulkData => {

                            if(bulkData.bulk_id === bulkId){
                                rowData["n_var"]        = bulkData.n_var;
                                rowData["expected_VAF"] = bulkData.expected_VAF;
                                rowData["read_depth"]   = bulkData.read_depth;
                                rowData["vaf"]          = bulkData.vaf;
                                return true;
                            }
                        });
                    }else{
                        rowData["n_var"]        = "NA";
                        rowData["expected_VAF"] = "NA";
                        rowData["read_depth"]   = "NA";
                        rowData["vaf"]          = "NA";
                    }

                    datas.push(rowData);
                }
            }


        }
        
        setCardTitle(tempCardTitle);
        setRows(datas)
        
        return datas;
    }

    const sortedRows = useMemo(() =>{
        
        let sortedRows: any[] = [...rows];

        if (sortDirection === 'NONE') return sortedRows;

        switch (sortColumn) {
            case 'lineage_id_cindel':
            case 'Location':
            case 'Gene_name':
            case 'Exonic_variant_type':
            case 'Amino_acid_change':
                sortedRows = sortedRows.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn]));
                break;
            case 'CHROM':
            case 'POS':
            case 'REF':
            case 'ALT':
            case 'read_depth':
            case 'n_var':
            case 'vaf':
              sortedRows = sortedRows.sort((a, b) =>{ 
                let aValue:number = a[sortColumn] === "NA" ? 0 : a[sortColumn]
                let bValue:number = b[sortColumn] === "NA" ? 0 : b[sortColumn]
                  return aValue - bValue
                });
              break;
            default:
          }

        return sortDirection === 'DESC' ? sortedRows.reverse() : sortedRows;

    },[rows, sortDirection, sortColumn]);

    return (
        <React.Fragment>
            <div ref={focusTarget} className="row">
            <div className="col-md-12">
                <div className="card card-primary">
                    <div className="card-header">
                    <h3 className="card-title">{cardTitle}</h3>
                    </div>
                    <div className="card-body">
                        <div >
                        <DataGrid
                            columns={columns}
                            rows={sortedRows} 
                            sortColumn={sortColumn}
                            sortDirection={sortDirection}
                            onSort={handleSort}
                            rowHeight={25}
                            headerRowHeight={35}
                            className="fill-grid3"
                            rowClass={row => {
                                        if(selectedRowVarId === row.var_id){
                                            return selectedHighlightClassname;
                                        }
                                        return undefined;
                                    //  return row.Target_seq.includes('Y') ? highlightClassname : undefined
                                    }
                                }
                        />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </React.Fragment>
    );
}

export default Screen3Grid;